import router from './router/index'
import store from './store'
import { getCookie } from "./utils/cookieUtil";

router.beforeEach(async (to, from, next) => {

  if (getCookie('userInfo')) {
    store.dispatch('getUserInfo');
  }
  if (getCookie('token')) {
    store.dispatch('getToken');
  }
  next()
});



// WEBPACK FOOTER //
// ./src/permission.js